module.exports = __webpack_public_path__ + "img/download-banner.27b73a52.webp";